module.exports = __webpack_public_path__ + "static/media/insight-578.e3796edb.mp3";